module.exports = __webpack_public_path__ + "images/wechat/img-share-5016cb4b492943234cb2ae25e00bb571.jpg";